export default [
  {
    text: "国网江苏电力官方授权电费缴费渠道一览表",
    url: "/pdf/guanfangJfqd/国网江苏电力官方授权电费交费渠道一览表.pdf",
  },
];
